import { Typography, Grid, Box, Button, Divider, Breadcrumbs, Link } from '@mui/material'
import { useState, useEffect } from 'react'
import SiblingDetails from '../../Components/CareNetwork/SiblingDetails'
import { sendGet } from '../../hooks/use-fetch'
import { type CareNetworkDetailsModel } from '../../Components/CareNetwork/CareNetworkDetails'
import { useLocation, useNavigate, useParams } from 'react-router'
import CaregiverDetails from '../../Components/CareNetwork/CaregiverDetails'

export function CareNetworkDetails (): JSX.Element {
  const [careNetwork, setCareNetwork] = useState<CareNetworkDetailsModel | null>(null)
  const nav = useNavigate()
  const { id } = useParams()
  const redirectText = useLocation()?.state?.redirectText ?? 'Care Network Details'
  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response, success } = await sendGet(
          `/CareNetworkDetails/GetDetails?childId=${id ?? ''}`, {})

      success && setCareNetwork(response.response)
    }

    void fetchData()
  }, [id])
  const goBack = (): void => {
    nav(-1)
  }

  return <>
    <Typography variant='h5' gutterBottom>
      Care Network Details
    </Typography>
    <Breadcrumbs>
      <Link onClick={goBack} sx={{ textTransform: 'none', color: 'inherit', textDecorationLine: 'none', cursor: 'pointer' }}>Return to {redirectText}</Link>
    </Breadcrumbs>

    <Typography variant='h6' sx={{ fontWeight: 'bold' }} gutterBottom>Caregivers</Typography>
    <Grid container spacing={2}>
      {careNetwork?.caregivers?.map((caregiver) => (
        <Grid item xs={12} sm={6} lg={4} xl={3} key={caregiver.id}>
          <CaregiverDetails
            caregiverId={caregiver.id}
            childId={Number(id)}
          />
        </Grid>
      ))}
    </Grid>
    <Box sx={{ display: 'flex', justifyContent: 'center', paddingY: 2 }}>
      <Button
        variant='outlined'
        sx={{ px: 4, textTransform: 'none' }}
        onClick={() => {
          nav(`/CaregiverDetails/Edit/Child/${id ?? ''}`)
        }}
      >
        Add Caregiver
      </Button>
    </Box>
    <Divider sx={{ paddingTop: 0, marginBottom: 2 }} />
    <Typography variant='h6' sx={{ fontWeight: 'bold' }} gutterBottom>Siblings</Typography>
    <Grid container spacing={2}>
      {careNetwork?.siblings?.map((sibling) => (
        <Grid item xs={12} sm={6} lg={4} xl={3} key={sibling.id}>
          <SiblingDetails
            siblingId={sibling.id}
            childId={Number(id)}
          />
        </Grid>
      ))}
    </Grid>
    <Box sx={{ display: 'flex', justifyContent: 'center', paddingTop: 2 }}>
      <Button
        variant='outlined'
        sx={{ px: 4, textTransform: 'none' }}
        onClick={() => {
          nav(`/SiblingDetails/Edit/Child/${id ?? ''}`)
        }}
        data-testid='addSiblingButton'
      >
        Add Sibling
      </Button>
    </Box>
    <Button data-testid='ReturnButton' variant='outlined' onClick={() => { nav(-1) }} sx={{ textTransform: 'none' }}>Return</Button>
  </>
}
